export const STATUSES = [
  "Not Started", "Research", "In Progress", "In Review",
  "Delivered", "Revision Requested", "Approved", "Closed", "On Hold",
];

export const PRIORITIES = ["P0", "P1", "P2"];
export const WORK_TYPES = ["Script", "Research", "Design", "Operations", "Advisory", "Review", "Admin", "Shoots"];
export const FORMATS = ["Short Form (SF)", "Long Form (LF)", "Not Applicable"];
export const AUDIENCES = ["ETM", "NTM", "Not Applicable"];

// Phase 2 — Projects
export const PROJECT_TYPES = ["Content IP", "Advisory", "Operations", "Hiring", "Compliance", "Legal", "Finance"];
export const PROJECT_FORMATS = ["Short Form", "Long Form", "Mixed", "Not Applicable"];
export const PROJECT_STATUSES = ["Active", "Paused", "Completed", "Closed"];

// Phase 3 — Internal Ops
export const OPS_CATEGORIES = ["Compliance", "Legal", "Finance", "Hiring", "Tech & Infrastructure", "Business Development"];
export const RECURRENCES = ["None", "Weekly", "Monthly", "Quarterly", "Annually"];
export const PENDING_EXTERNAL = "Pending External";

// Phase 4 — Clients
export const CLIENT_TYPES = ["Content Client", "Advisory Client", "Distribution Partner", "Internal"];
export const RELATIONSHIP_STATUSES = ["Active", "On Hold", "Completed", "Prospective"];
export const BILLING_MODELS = ["Monthly Retainer", "Per Deliverable", "Project-Based", "Not Applicable"];
export const INVOICE_CYCLES = ["Monthly", "Milestone-Based", "On Delivery", "Not Applicable"];

export const STATUS_COLORS = {
  "Not Started":        { bg: "#F3F4F6", text: "#6B7280", border: "#E5E7EB" },
  "Research":           { bg: "#EDE9FE", text: "#6D28D9", border: "#DDD6FE" },
  "In Progress":        { bg: "#DBEAFE", text: "#2563EB", border: "#BFDBFE" },
  "In Review":          { bg: "#FEF08A", text: "#A16207", border: "#FDE047" },
  "Delivered":          { bg: "#DCFCE7", text: "#15803D", border: "#BBF7D0" },
  "Revision Requested": { bg: "#FFEDD5", text: "#C2410C", border: "#FED7AA" },
  "Approved":           { bg: "#14532D", text: "#FFFFFF", border: "#166534" },
  "Closed":             { bg: "#374151", text: "#FFFFFF", border: "#4B5563" },
  "On Hold":            { bg: "#E5E7EB", text: "#4B5563", border: "#D1D5DB" },
  "Pending External":   { bg: "#FDF2F8", text: "#9D174D", border: "#FBCFE8" },
};

export const PRIORITY_COLORS = {
  P0: { bg: "#FEE2E2", text: "#DC2626", border: "#FCA5A5", label: "P0 · Urgent" },
  P1: { bg: "#FEF3C7", text: "#B45309", border: "#FCD34D", label: "P1 · Important" },
  P2: { bg: "#F3F4F6", text: "#4B5563", border: "#D1D5DB", label: "P2 · Backlog" },
};
